import {GalleryItem} from "../Gallery";

export const gallery2024Items: GalleryItem[] = [
"/static/Gallery/2024/1.jpg",
"/static/Gallery/2024/2.jpg",
"/static/Gallery/2024/3.jpg",
"/static/Gallery/2024/4.jpg",
"/static/Gallery/2024/5.jpg",
"/static/Gallery/2024/6.jpg",
"/static/Gallery/2024/7.jpg",
"/static/Gallery/2024/8.jpg",
"/static/Gallery/2024/9.jpg",
"/static/Gallery/2024/10.jpg",
"/static/Gallery/2024/11.jpg",
"/static/Gallery/2024/12.jpg",
"/static/Gallery/2024/13.jpg",
"/static/Gallery/2024/14.jpg",
"/static/Gallery/2024/15.jpg",
"/static/Gallery/2024/16.jpg",
"/static/Gallery/2024/17.jpg",
"/static/Gallery/2024/18.jpg",
"/static/Gallery/2024/19.jpg",
"/static/Gallery/2024/20.jpg",
"/static/Gallery/2024/21.jpg",
"/static/Gallery/2024/22.jpg",
"/static/Gallery/2024/23.jpg",
"/static/Gallery/2024/24.jpg",
"/static/Gallery/2024/25.jpg",
"/static/Gallery/2024/26.jpg",
"/static/Gallery/2024/27.jpg",
"/static/Gallery/2024/28.jpg",
"/static/Gallery/2024/29.JPg",
"/static/Gallery/2024/30.JPg",
"/static/Gallery/2024/31.JPg",
"/static/Gallery/2024/32.JPg",
];
